import React from "react";
import { NavLink } from "react-router-dom";
import "./NavbarSecondary.css";

/**
 * Composant pour la barre de navigation secondaire
 * @param {Object} props - Les propriétés du composant
 * @param {Array} props.items - Items de navigation secondaire
 * @param {boolean} props.isMobile - Si le composant est affiché en version mobile
 */
const NavbarSecondary = ({ items = [], isMobile = false }) => {
  return (
    <nav className={`navbar-secondary ${isMobile ? "mobile" : ""}`}>
      {items.length > 0 && (
        <ul className="nav-list-secondary">
          {items.map((item, index) => (
            <li key={`secondary-${index}`} className="nav-item-secondary">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link-secondary ${isActive ? "active" : ""}`
                }
                end={item.exact ? "true" : undefined}
              >
                {item.icon && <span className="nav-icon">{item.icon}</span>}
                <span className="nav-label">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default NavbarSecondary; 